import i18n from '../utils/i18n';
import { createApp } from 'vue';
import { createBootstrap } from 'bootstrap-vue-next'
import WishLists from '../components/WishLists.vue';

export class WishListsLoader {
  constructor() {
    const wishListsElements = document.querySelectorAll('.vue-wish-lists');
    if (wishListsElements.length == 0) {
      return;
    }

    const itemIds = Array.from(wishListsElements).map(el => el.dataset.itemId);

    fetch(`/wish_lists.json?item_ids=${itemIds.join(',')}`, {
      headers: {
        'Accept': 'application/json'
      }
    })
    .then(response => response.json())
    .then(data => {
      wishListsElements.forEach(el => {
        const jsonData = {
          itemId: parseInt(el.dataset.itemId, 10),
          wishLists: data.wish_lists || [],
          selectedWishLists: data.item_ids[el.dataset.itemId] || []
        };
        const wishListApp = createApp(WishLists, jsonData);
        wishListApp.use(i18n);
        wishListApp.use(createBootstrap());
        wishListApp.mount(el);
      });
    });
  }
}
